import EventEmitter from "../utils/EventEmitter";
import noUiSlider from 'nouislider';

export default class RangePeriod extends EventEmitter {
    constructor(element) {
        super();
        this.el = element


        this.customRangeContainer = this.el.querySelector('.custom-range-container')
        this.realInputsContainer = this.el.querySelector('.real-inputs-container')

        this.minDate = this.realInputsContainer.querySelector('input[name*="[min]"]')
        this.maxDate = this.realInputsContainer.querySelector('input[name*="[max]"]')

        this.createNoUiSliderRange()

        this.realInputsContainer.style.display = 'none'

    }

    createNoUiSliderRange() {
        // avec nouislider on fait un double range pour les dates allant de 1991 à l'année en cours
        const slider = document.createElement('div')
        slider.classList.add('range-slider')

        this.customRangeContainer.appendChild(slider)

        const currentYear = new Date().getFullYear()

        noUiSlider.create(slider, {
            start: [this.minDate.value ? parseInt(this.minDate.value) : 1936, this.maxDate.value ? parseInt(this.maxDate.value) : currentYear],
            connect: true,
            step: 1,
            tooltips: [true, true],
            range: {
                'min': 1936,
                'max': currentYear
            },
            // Le format de la valeur doit être un entier
            format: {
                to: function (value) {
                    return parseInt(value)
                },
                from: function (value) {
                    return parseInt(value)
                }
            }
        })

        // On met à jour les valeurs des inputs en temps réel
        slider.noUiSlider.on('update', (values, handle) => {
            const value = values[handle]

            if (handle) {
                this.maxDate.value = value
            } else {
                this.minDate.value = value
            }
        })
    }
}
